import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useLocation, useNavigate } from "react-router-dom";
import { registerZipUser } from "../../http/http";
import { useDispatch } from "react-redux";
import { setUserZip } from "../../store/slices/userZipGameTokenSlice";
import { toast } from "react-toastify";

const ZipGameUserDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const msisdn = location?.state?.msisdn || "";
  const [fullName, setFullName] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (!msisdn) {
      navigate("/register/zip-game");
    }
  }, [msisdn, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!fullName || fullName.trim().length == 0) {
        return;
      }

      const response = await registerZipUser(msisdn, fullName);
      console.log(response?.data?.result, 'response==');

      if (response?.data?.result?.regiserStatus == 1) {
        // user is already registered
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else if (response?.data?.result?.regiserStatus == 2) {
        // new user registered successfully!
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else {
        // something went wrong! please try again!
        toast.error(t("203"));
      }

    } catch (error) {
      console.log(error, 'error--');
    }
  };

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>{t("173")}</div>
          <h1 className={classes.heroTitle}>{t("196")}</h1>
          <p className={classes.heroText}>
            {t("197")}
          </p>
        </div>

        <ZipGameStepper currentStep={3} />

        <div className={classes.formCard}>
          <form className={classes.section} onSubmit={handleSubmit}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("198")}</h2>
              <p className={classes.sectionText}>
                {t("199")}
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="fullName">
                {t("200")}
              </label>
              <input
                id="fullName"
                type="text"
                className={classes.input}
                placeholder={t("201")}
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            <div className={classes.actionRow}>

              <button type="submit" className={classes.primaryBtn}>
                {t("202")}
              </button>
              <button
                type="button"
                className={classes.secondaryBtn}
                onClick={() =>
                  navigate("/register/zip-game")
                }
              >
                {t("193")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ZipGameUserDetails;